import React from 'react';
import { connect } from 'react-redux';
import { setLocale } from '../../actions/intl';
import { getDynamicTitleByLocale } from '../../helpers/getDynamicTitle';
import {
  t, PHONE, initReveal,
  Header, Footer, CallBar
} from './SiteChrome';

// Halaman legal tidak punya konten terstruktur selain identitas dokumen itu
// sendiri — WebPage sudah cukup, dan menyatakan penerbitnya.
const ld = (name, url) => ({
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name,
  url,
  inLanguage: ['en', 'ar'],
  publisher: {
    '@type': 'AutoRepair',
    name: 'Bas Recovery',
    telephone: PHONE,
    url: 'https://basrecovery.com/'
  }
});

/*
 * Halaman legal (privacy, terms) di dalam chrome situs publik.
 *
 * Teksnya TIDAK ada di copy.json: isinya hidup di tabel StaticPage dan client
 * mengeditnya dari dashboard (Static Page manage). Menyalinnya ke copy.json
 * berarti dua sumber kebenaran untuk dokumen hukum — dan yang di dashboard akan
 * diam-diam basi. Jadi komponen ini cuma membungkus HTML yang datang dari DB.
 *
 * HTML dari DB dirender apa adanya. Sumbernya editor Quill di dashboard admin
 * (hanya admin login yang bisa menulis ke situ), bukan input publik.
 *
 * PERINGATAN ISI: baris StaticPage yang ada semuanya legal APLIKASI MOBILE. Tidak
 * menyebut situs web, formulir callback, maupun cookie/pixel analitik. Perlu
 * teks baru dari client sebelum situs ini benar-benar tayang.
 */

class LegalPage extends React.Component {
  state = { navOpen: false };

  toggleNav = () => this.setState(s => ({ navOpen: !s.navOpen }));
  closeNav = () => this.setState({ navOpen: false });

  switchLang = () => {
    const next = this.props.currentLocale === 'ar' ? 'en-US' : 'ar';
    document.documentElement.lang = next;
    this.props.setLocale({ locale: next });
  };

  componentDidMount() {
    this.onKey = e => { if (e.key === 'Escape') this.closeNav(); };
    document.addEventListener('keydown', this.onKey);
    this.io = initReveal();
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKey);
    if (this.io) this.io.disconnect();
  }

  render() {
    const { navOpen } = this.state;
    const { result, current, titleKey } = this.props;
    const L = this.props.currentLocale || 'en-US';
    const tx = (k, v) => t(L, k, v);

    // Terjemahan per bahasa disimpan terpisah di dynamicStaticContentSettings.
    // Kalau baris untuk bahasa aktif tidak ada, jatuh ke kolom content utama.
    const perLocale = getDynamicTitleByLocale({
      dynamicHomePageSettings: result && result.dynamicStaticContentSettings,
      locale: L
    });
    const html = (perLocale && perLocale[0] && perLocale[0].content) ||
      (result && result.content) || '';

    return (
      <div>
        <a className="skip" href="#main">{tx('nav.skip')}</a>

        <Header
          locale={L} current={current}
          navOpen={navOpen}
          onToggleNav={this.toggleNav}
          onCloseNav={this.closeNav}
          onSwitchLang={this.switchLang}
        />

        <main id="main">
          <section className="hero" style={{ paddingBlock: 'clamp(40px,6vw,68px) clamp(28px,4vw,40px)' }}>
            <div className="wrap-narrow">
              <p className="eyebrow">{tx('legal.eyebrow')}</p>
              <h1 style={{ fontSize: 'var(--fs-h1)', maxWidth: '20ch' }}>{tx(titleKey)}</h1>
            </div>
          </section>

          <section style={{ paddingTop: 0 }}>
            <div className="wrap-narrow">
              {/* h2 tersembunyi. Isi legal datang dari editor Quill dan hanya
                  memakai <p><strong>, sehingga dokumen melompat h1 → h3 (h3
                  pertama ada di footer). Judul bagian ini menutup lompatan itu
                  untuk pembaca layar tanpa mengubah tampilan. */}
              <h2 className="sr">{tx(titleKey)}</h2>
              {html
                ? <div className="legal" dangerouslySetInnerHTML={{ __html: html }} />
                : <p>{tx('legal.empty')}</p>}
            </div>
          </section>
        </main>

        <Footer locale={L} />
        <CallBar locale={L} />

        <script type="application/ld+json" dangerouslySetInnerHTML={{
          __html: JSON.stringify(ld(t('en-US', titleKey), `https://basrecovery.com${current}`))
        }} />
      </div>
    );
  }
}

const mapState = state => ({ currentLocale: state?.intl?.locale });
const mapDispatch = { setLocale };

export default connect(mapState, mapDispatch)(LegalPage);
